exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:fontello-vod-widget;src:url(" + require("widget/player-widget/fontello/font/fontello.woff") + ") format(\"woff\");font-weight:400;font-style:normal}.icon__icon__39l-x{font-family:fontello-vod-widget;font-style:normal;font-weight:400;speak:none;text-decoration:inherit;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transition:all .2s}", ""]);

// exports
exports.locals = {
	"icon": "icon__icon__39l-x"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/icon/icon.styl
// module id = 1300
// module chunks = 0 1 2 3